<app-layout-container [tabbar]="tabbar()" [useCard]="false" [isPublicPage]="true">
  <cfp-building-report-content [buildingPublicSharedId]="publicSharedId" />
</app-layout-container>
